/**
 * Utility function to help exhaustively handle enums and discriminated unions.
 * @param variable - the variable under assertion
 *
 * Example:
 * ```
 * enum Color {
 *   Blue = 'Blue',
 *   Red = 'Red',
 * }
 *
 * switch (color) {
 *   case Color.Blue:
 *     return "The color is blue";
 *   default:
 *     assertNever(color); // Throws compile time error as Color.Red has not been handled
 * }
 * ```
 */
export const assertNever = (variable: never) => {
  throw new Error(`Expected ${variable} to be of type \`never\`.`);
};
